import React from 'react'

interface IProps {
    error?: string
}

export default function ErrorForm(props: IProps): React.ReactElement {
    return <div className="error-box">{props.error ? <p className="error-msg">* {props.error}</p> : <></>}</div>
}
